import { classNames } from "../../utils"
import { Block, type BlockProps } from "../Block"

export type FlexProps = BlockProps

export function Flex({ className, ref, ...rest }: FlexProps) {
  return <Block className={classNames("flex", className)} ref={ref} {...rest} />
}
